export const cognitoConfig = {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    endpoint: import.meta.env.VITE_COGNITO_ENDPOINT,
}
